import { BoxGeometry } from "three";

export const defaultVerticalPlaneGeometry = new BoxGeometry(0.9, 0.14, 0);
